import { ContentsInProgress } from './ContentsInProgress';
import { MainContents } from './MainContents';
import { MyContents } from './MyContents';
import { NewContents } from './NewContents';
import { PaginatedContents } from './PaginatedContents';

export const Sections = {
  NewContents,
  MyContents,
  ContentsInProgress,
  MainContents,
  PaginatedContents,
};
